import React from 'react';
import {Grid, Typography} from '@mui/material';
import Dialog from 'components/Dialog';
import AsyncContainer from 'components/AsyncContainer';
import Panel from 'components/Panel';
import {Trans, useTranslation} from 'react-i18next';
import Button from 'components/Button';
import {PrimaryButton} from 'components/buttons/PrimaryButton';
import {INav} from 'features/layout/redux/helpers/FoldersHelper';
import {DiplomatObjectType} from 'types/DiplomatObjectType';
import {useDispatch, useSelector} from 'react-redux';
import {default as transactionsSelectors} from 'redux/transactions/selectors';
import {unpackId} from 'common/diplomatIdUtil';
import {useTransactionsRefs} from 'redux/transactions/hooks/useTransactionsRefs';
import TransactionReferencesAlert from './TransactionReferencesAlert';
import {useDeleteApi} from 'common/hooks/useDeleteApi';
import api from 'api';
import {layoutActions} from 'features/layout/redux';
import {useSynchronizationsRefs} from 'redux/synchronizations/hooks/useSynchronizationsRefs';

type DeletePartnerDialogProps = {
   data: INav;
   onClose: () => void;
};

const DeletePartnerDialog = ({data, onClose}: DeletePartnerDialogProps) => {
   const {t} = useTranslation();

   const {id} = unpackId(data.id);
   const transactions = useTransactionsRefs(id, 'partner');
   const synchronizations = useSynchronizationsRefs(id, 'partner');

   const dispatch = useDispatch();
   const onSuccess = () => {
      dispatch(layoutActions.loadTreeNav());
      onClose();
   };
   const {request: onConfirm} = useDeleteApi(api.partners + `/${id}`, {
      onSuccess,
   });

   const isTransactionsFetching = useSelector(transactionsSelectors.isFetching);
   const hasReferences = transactions.length || synchronizations.length;
   const objectName =
      data.objectType === DiplomatObjectType.enum.EXTERNAL_PARTNER
         ? t('Public Partner')
         : t('Trusted Partner');
   return (
      <Dialog maxWidth="sm" header={t('Delete Partner')} close={onClose}>
         <AsyncContainer loading={isTransactionsFetching}>
            <Panel root>
               {hasReferences ? (
                  <TransactionReferencesAlert
                     data={data}
                     objectName={objectName}
                     transactions={transactions}
                     synchronizations={synchronizations}
                  />
               ) : (
                  <Typography>
                     <Trans t={t}>
                        Do you really want to delete {{objectName}} "{{name: data.name}}"?
                     </Trans>
                  </Typography>
               )}
            </Panel>
            <Grid container spacing={2} justifyContent={'center'}>
               <Grid item>
                  <PrimaryButton onClick={() => onConfirm()}>{t('OK')}</PrimaryButton>
               </Grid>
               <Grid item>
                  <Button onClick={onClose}>{t('Cancel')}</Button>
               </Grid>
            </Grid>
         </AsyncContainer>
      </Dialog>
   );
};

export default DeletePartnerDialog;
